import MuiListItemIcon from './MuiListItemIcon';
import MuiFab from './MuiFab';

export default {
  MuiListItemIcon,
  MuiFab
};
